import { Typography } from '@progress/kendo-react-common'
import { Notification } from '@progress/kendo-react-notification'
import styled from 'styled-components'

// Toast con look más suave: esquinas redondeadas, sombra elevada y padding cómodo,
// con el ícono alineado al inicio junto al título
export const NotificationStyled = styled(Notification)({
  minWidth: '21.875rem',
  borderRadius: 'var(--xts-radius-md)',
  border: 'none',
  boxShadow: '0 0.375rem 1rem rgba(0, 0, 0, 0.18)',
  padding: '0.75rem 1rem',
  alignItems: 'flex-start',
})

export const TitleStyled = styled(Typography.p)({
  fontWeight: 600,
  fontSize: '0.875rem',
  margin: '0% !important',
  marginBottom: '0.25rem !important',
})

export const MessageStyled = styled(Typography.p)({
  margin: '0% !important',
  fontSize: '0.8125rem',
  lineHeight: 1.4,
  opacity: 0.95,
  textWrap: 'wrap',
  wordBreak: 'break-word',
})
